(function (upp) {
    'use strict';
    upp.directive('passwordConfirmationFor', [function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function($scope, element, attrs, ngModel) {
                var password = null;
                var passwordConfirmation = null;
                var setPasswordValidity = function() {
                    ngModel.$setValidity('passwordConfirmation', password === passwordConfirmation)
                };
                $scope.$watch(attrs['ngModel'], function(_password) {
                    passwordConfirmation = _password;
                    setPasswordValidity();
                });
                $scope.$watch(
                    function() { return $scope.$eval(attrs['passwordConfirmationFor']) },
                    function(_password) {
                        password = _password;
                        setPasswordValidity();
                    }
                )
            },
        };
    }]);
}(upp));


// WEBPACK FOOTER //
// ./src/app/modules/customer-account/directives/password-confirmation-for.directive.js